import { render, staticRenderFns } from "./ConfigurationErrorResult.vue?vue&type=template&id=5db7d727"
import script from "./ConfigurationErrorResult.vue?vue&type=script&lang=js"
export * from "./ConfigurationErrorResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports